export const QUESTION_OPTIONS = {
  es: {
    alcohol: {
      type: [
        { label: 'Cerveza / vino', value: 'AT1' },
        { label: 'Licores', value: 'AT2' },
        { label: 'Destilados', value: 'AT3' }
      ],
      amount: [
        { label: 'De 1 a 2', value: 'AC1' },
        { label: 'De 2 a 3', value: 'AC2' },
        { label: 'De 3 a 5', value: 'AC3' },
        { label: 'Más de 5', value: 'AC4' }
      ]
    },
    smoking: {
      type: [
        { label: 'Cigarrillos', value: 'FT1' },
        { label: 'Puros', value: 'FT2' }
      ],
      amount: [
        { label: 'De 1 a 2', value: 'FC1' },
        { label: 'De 2 a 5', value: 'FC2' },
        { label: 'De 5 a 10', value: 'FC3' },
        { label: 'De 10 a 20', value: 'FC4' },
        { label: 'Más 20', value: 'FC5' }
      ]
    }
  }
}

export const TRANSITION_SIDE_DIRECTIONS: Record<string, string> = Object.freeze({
  LEFT: 'left',
  RIGHT: 'right'
})

export const RATES: Record<string, string> = Object.freeze({
  monthly: 'mensual',
  bimonthly: 'bimestral',
  quarterly: 'quarterly',
  semestral: 'semestral',
  annual: 'anual',
  unique: 'unica'
})

export const SIGNATURE_HASH_SEPARATOR = '||'

export const IBAN_SIZES = {
  DE: 22, // Alemania
  AD: 24, // Andorra
  AT: 20, // Austria
  BE: 16, // Bélgica
  BG: 22, // Bulgaria
  CZ: 24, // Chequia
  CY: 28, // Chipre
  HR: 21, // Croacia
  DK: 18, // Dinamarca
  SK: 24, // Eslovaquia
  SI: 19, // Eslovenia
  ES: 24, // España
  EE: 20, // Estonia
  FI: 18, // Finlandia
  FR: 27, // Francia
  GR: 27, // Grecia
  HU: 28, // Hungría
  IS: 26, // Islandia
  IE: 22, // Irlanda
  IT: 27, // Italia
  LV: 21, // Letonia
  LI: 21, // Liechtenstein
  LT: 20, // Lituania
  LU: 20, // Luxemburgo
  MT: 31, // Malta
  MC: 27, // Mónaco
  NO: 15, // Noruega
  NL: 18, // Países Bajos
  PL: 28, // Polonia
  PT: 25, // Portugal
  GB: 22, // Reino Unido
  RO: 24, // Rumanía
  SM: 27, // San Marino
  SE: 24, // Suecia
  CH: 21, // Suiza
  VA: 22 // Ciudad del Vaticano
}
export const MAX_CHARS_PASSPORT = 9
export const MAX_CHARS_POLICY_NUMBER = 9
export const SPAIN_PREFIX = '+34'
